import { Col, Row, Form, Input, Button, Card } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import FancyVideo from "react-videojs-fancybox";
const { Meta } = Card;
const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent12 = () => {
  return (
    <>
      <section className="py-5 home-modals-box">
        <Row justify={"center"}>
          <Col lg={18}>
            <Row justify="center" className="items-center">
              <Col xxl={18} md={20} sm={20} xs={23}>
                <h3 className="font-goldman text-white text-[40px] leading-[75px] text-center">
                  We Provide Best
                </h3>
                <p className="text-[#666666] text-[15px] antialiased text-center">
                  Absolutely, providing only the best is our top priority. From
                  our meticulously maintained fleet of luxury vehicles to our
                  professional chauffeurs and personalized service, we are
                  dedicated to delivering excellence in every aspect of your
                  experience. Our commitment to quality extends to every detail,
                  ensuring that your journey is not just satisfactory, but truly
                  exceptional.
                </p>
              </Col>
            </Row>
            <Row justify="center" className="items-center py-6">
              <Col lg={14}>
                <Row gutter={[16, 16]} justify={"center"}>
                  <Col xxl={12} md={12} sm={20} xs={23}>
                    <div className="provide-best-boxs">
                      <h2 className="font-goldman text-white text-[50px] leading-[75px]">
                        21+
                      </h2>
                      <p className="text-[#666666] text-[22px] antialiased text-center">
                        Years Of Experience
                      </p>
                    </div>
                  </Col>
                  <Col xxl={12} md={12} sm={20} xs={23}>
                    <div className="provide-best-boxs">
                      <h2 className="font-goldman text-white text-[50px] leading-[75px]">
                        157K
                      </h2>
                      <p className="text-[#666666] text-[22px] antialiased text-center">
                        Worldwide Rent Stations
                      </p>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row justify="center" className="items-center py-6">
              <Col lg={14}>
                <div className="anim">
                  <img
                    src={ImageUrl("provideBest.png")}
                    alt="vector"
                    className=""
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent12;
